import { Section } from '@/components/ui/index.js';
import type { UserDetailResponse } from '@/lib/types.js';

type Device = UserDetailResponse['devices'][number];

interface Props {
  devices: readonly Device[];
  fmtDateTime: (s: string | null | undefined) => string;
}

export function DevicesCard({ devices, fmtDateTime }: Props): JSX.Element {
  return (
    <Section title={`活跃设备（${devices.length}）`} className="mb-6">
      {devices.length === 0 ? (
        <p className="text-sm text-slate-500">无活跃设备</p>
      ) : (
        <table className="w-full text-sm">
          <thead className="text-xs text-slate-500">
            <tr>
              <th className="text-left py-2">类型</th>
              <th className="text-left py-2">平台</th>
              <th className="text-left py-2">名称</th>
              <th className="text-left py-2">最近活跃</th>
              <th className="text-left py-2">注册</th>
            </tr>
          </thead>
          <tbody>
            {devices.map((d) => (
              <tr key={d.id} className="border-t border-white/[0.08]">
                <td className="py-2 text-slate-300">
                  {d.device_type === 'desktop' ? '桌面' : '移动'}
                </td>
                <td className="py-2 text-slate-300">{d.platform}</td>
                <td className="py-2 text-slate-300">{d.name ?? '—'}</td>
                <td className="py-2 text-slate-400">
                  {d.last_active_at !== null ? fmtDateTime(d.last_active_at) : '—'}
                </td>
                <td className="py-2 text-slate-400">{fmtDateTime(d.created_at)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </Section>
  );
}
